import React, {useState, useEffect} from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import AudioPlayer, {RHAP_UI} from 'react-h5-audio-player'
import {useLazyQuery} from '@apollo/client'
import {GETCLIENTFEATUREFLAGS} from '../../../../utils/GraphQLAPI'
import 'react-h5-audio-player/lib/styles.css'

type Props = {
  startTime: number
  endTime: number
  mp3: string
  disableClick: (e: any) => void
  totalCount: number
  type: string
}

export const Audio = ({startTime, endTime, mp3, disableClick, totalCount, type}: Props) => {
  const [audioDisable, setAudioDisable] = useState<any>(false)
  const [loaded, setLoaded] = useState<any>('')
  const [loader, setLoader] = useState<boolean>(true)
  const handleOnPlay = (e: any) => {
    setAudioDisable(true)
    e.target.currentTime = startTime
    disableClick('disable')
  }

  const handleListen = (e: any) => {
    if (type !== 'PLAYALL') {
      if (e.target.currentTime > endTime) {
        e.target.pause()
        setAudioDisable(false)
      }
    }
  }

  const handleLoadStart = (e: any) => {
    setLoader(true)
    setLoaded('audioLoader')
    return false
  }
  const handleLoaded = (e: any) => {
    setLoader(false)
    e.target.pause()
    setLoaded('')
  }

  const handleOnPause = (e: any) => {
    e.target.pause()
    setAudioDisable(false)
    disableClick('')
  }

  return (
    <div className='player-container'>
      {loader && <label className='loader'></label>}
      <AudioPlayer
        className={`testing ${audioDisable}  ${loaded}`}
        src={mp3}
        onPlay={(e) => handleOnPlay(e)}
        showJumpControls={false}
        customProgressBarSection={[RHAP_UI.CURRENT_TIME]}
        customControlsSection={[RHAP_UI.MAIN_CONTROLS]}
        showDownloadProgress={true}
        progressUpdateInterval={20}
        onListen={(e) => handleListen(e)}
        onLoadedData={(e) => handleLoaded(e)}
        onLoadStart={(e) => handleLoadStart(e)}
        onPause={(e) => handleOnPause(e)}
      />
    </div>
  )
}

type props = {
  data: any
  recordingTab: any
  customerData: any
}

// const Answers=()=>{
//   return(

//   )
// }

export const ScriptPromptComponent = ({data, recordingTab, customerData}: props) => {
  const MySwal = withReactContent(Swal)
  const [questions, setQuestions] = useState<any>()
  const [download, setDownload] = useState<boolean>(false)
  const [disablePlayer, setDisablePlayer] = useState<any>('')

  const [getClientFeatureflags, {data: featureFlags}] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: 'network-only',
  })
  useEffect(() => {
    getClientFeatureflags()
  }, [])
  useEffect(() => {
    if (data && data?.calls && data?.calls.length > 0) {
      setQuestions(data.calls[recordingTab])
    }
  }, [data, recordingTab])

  const handleScriptDownload = async () => {
    if (!download) {
      const recordingFileName = `${customerData.firstName}_${questions?.callTime}_Recording.wav`
      setDownload(true)
      await fetch(questions?.recordingSignedUrl?.preSignedUrl, {
        cache: 'no-cache',
      })
        .then(async (response: any) => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(await response.blob())
          link.download = recordingFileName
          link.click()
          setDownload(false)
        })
        .catch((e: any) => {
          setDownload(false)
          MySwal.fire({
            icon: 'error',
            title: 'Recording not found!',
          })
        })
    }
  }

  const disableMode = (target: any) => {
    setDisablePlayer(target)
  }

  return (
    <>
      <div className='card'>
        <div className={`card-body script-recording ${disablePlayer}`}>
          <h4 className='text-gray-800 fs-3 fw-bold mb-4'>Script Recording</h4>
          {Boolean(questions?.recordingSignedUrl?.preSignedUrl) && (
            <div className='app-container  container-xxl d-flex flex-stack justify-content-end w-100 mb-4'>
              {customerData?.tpvType !== 'SMS TPV' && (
                <div className='d-flex align-items-center gap-2 gap-lg-3'>
                  <button
                    className='btn btn-active-light-primary btn-light-primary fs-6 fs-base'
                    onClick={handleScriptDownload}
                  >
                    {download && <div className='spinner-border spinner-border-sm ms-1 me-2' />}
                    {!download && (
                      <span className='svg-icon svg-icon-6 svg-icon-muted me-2'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='16'
                          height='16'
                          fill='none'
                          className='bi bi-download'
                          viewBox='0 0 16 16'
                        >
                          <path
                            d='M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z'
                            fill='currentColor'
                          />
                          <path
                            d='M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                    )}
                    <span className='csvTemplate'>Download</span>
                  </button>
                  <button className='btn btn-active-light-primary btn-light-primary fs-6 px-1 py-1'>
                    <div className='d-flex align-items-center play-all'>
                      <Audio
                        disableClick={disableMode}
                        mp3={(questions && questions.recordingSignedUrl?.preSignedUrl) || ''}
                        startTime={0}
                        endTime={questions.callActualDuration}
                        totalCount={questions?.answers.length}
                        type='PLAYALL'
                      />
                      <div className='fs-5 w-70px'>Play All</div>
                    </div>
                  </button>
                </div>
              )}
            </div>
          )}
          <div>
            <div className='min-h-300px'>
              {questions?.answers && questions?.answers.length === 0 && (
                <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
                  <div>No Questions Added</div>
                </div>
              )}
              {questions?.answers &&
                questions.answers.map((answer: any, index: any) => {
                  return (
                    <div key={index} className='bg-f4f4f4 p-5 mb-7 rounded-3'>
                      <div className='d-flex gap-4 align-items-center'>
                        <div
                          className='bg-gray-700 p-2 w-30px h-30px text-center text-white'
                          style={{borderRadius: '6px'}}
                        >
                          {index + 1}
                        </div>
                        <div className='text-gray-600 w-100 m-0'>
                          <p className='text-gray-600 w-100 m-0'>{answer.questionDescription}</p>
                          {featureFlags?.getClientFeatureFlags?.isTranscribedResponseRequired && (
                            <label className='answer-label'>Answer : {answer.description}</label>
                          )}
                        </div>
                        {customerData?.tpvType !== 'SMS TPV' && (
                          <Audio
                            disableClick={disableMode}
                            mp3={questions?.recordingSignedUrl?.preSignedUrl || ''}
                            startTime={answer.recordingStartedAt / 1000}
                            endTime={answer.recordingEndAt / 1000}
                            totalCount={questions?.answers.length}
                            type='PLAY'
                          />
                        )}
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
